import React from "react";
import { AlertTriangle, X } from "lucide-react";

function RepertoireDeleteModal({ open, onClose, repertoire, onConfirm, loading }) {
    if (!open || !repertoire) return null;

    return (
        <div className="rep-overlay" onMouseDown={onClose}>
            <div className="rep-modal" onMouseDown={(e) => e.stopPropagation()}>
                <div className="rep-modal__header">
                    <div className="rep-modal__title">
                        <AlertTriangle size={16} style={{ color: "#ee645f" }} />
                        Confirmation de suppression
                    </div>

                    <button type="button" className="rep-icon-btn" onClick={onClose}>
                        <X size={15} />
                    </button>
                </div>

                <div className="rep-modal__body">
                    <p className="rep-delete-text">
                        Voulez-vous vraiment archiver le répertoire :
                    </p>
                    <div className="rep-delete-name">{repertoire.name}</div>

                    {/*{repertoire.childrenCount > 0 && (*/}
                    {/*    <div className="rep-delete-warning">*/}
                    {/*        Ce répertoire contient {repertoire.childrenCount} sous-répertoire(s).*/}
                    {/*    </div>*/}
                    {/*)}*/}
                </div>

                <div className="rep-modal__footer">
                    <button type="button" className="rep-btn rep-btn--ghost" onClick={onClose}>
                        Annuler
                    </button>
                    <button
                        type="button"
                        className="rep-btn rep-btn--danger"
                        onClick={onConfirm}
                        disabled={loading}
                    >
                        {loading ? "Suppression..." : "Archiver"}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default RepertoireDeleteModal;
